export default {
  sysid: 56// 系统ID
}



// WEBPACK FOOTER //
// ./src/utils/config.js